module.exports = __webpack_public_path__ + "static/media/mmm-icon-bumper.f3b53e57.svg";